import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Bell } from "lucide-react";
import http from "@/api";
import { useApp } from "@/context";

const IMGS = {
  "عيد-الأم": "https://images.unsplash.com/photo-1561181286-d3fee7d55364?w=600&q=70&auto=format&fit=crop",
  "عيد-ميلاد": "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600&q=70&auto=format&fit=crop",
  "زواج": "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=70&auto=format&fit=crop",
  "خطوبة": "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=600&q=70&auto=format&fit=crop",
  "تخرج": "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=600&q=70&auto=format&fit=crop",
  "مولود-جديد": "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=600&q=70&auto=format&fit=crop",
  "حب-ورومانسية": "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?w=600&q=70&auto=format&fit=crop",
  "شكر-وتقدير": "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=600&q=70&auto=format&fit=crop",
  "شفاء-عاجل": "https://images.unsplash.com/photo-1470509037663-253afd7f0f51?w=600&q=70&auto=format&fit=crop",
  "عيد-الفطر": "https://images.unsplash.com/photo-1519817650390-64a93db51149?w=600&q=70&auto=format&fit=crop",
  "عيد-الأضحى": "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=600&q=70&auto=format&fit=crop",
  "اليوم-الوطني": "https://images.unsplash.com/photo-1502977249166-824b3a8a4d6d?w=600&q=70&auto=format&fit=crop",
};
const SHORT_AR = {
  "عيد-الأم": "عيد الأم", "عيد-ميلاد": "أعياد ميلاد", "زواج": "زواج", "خطوبة": "خطوبة",
  "تخرج": "تخرج", "مولود-جديد": "مولود جديد", "حب-ورومانسية": "حب ورومانسية",
  "شكر-وتقدير": "شكر وتقدير", "عيد-الفطر": "عيد الفطر", "عيد-الأضحى": "عيد الأضحى",
  "اليوم-الوطني": "اليوم الوطني", "شفاء-عاجل": "شفاء عاجل",
};

function OccImg({ slug, emoji }) {
  const [ok, setOk] = useState(true);
  return IMGS[slug] && ok ? (
    <img src={IMGS[slug]} alt="" loading="lazy" onError={() => setOk(false)}
         className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
  ) : (
    <span className="text-4xl">{emoji || "🎁"}</span>
  );
}

/* تسوق حسب المناسبة — الوجهة من تبويب «المناسبات» بالشريط السفلي */
export default function GiftOccasions() {
  const { lang, user } = useApp();
  const ar = lang === "ar";
  const [pages, setPages] = useState(null);

  useEffect(() => {
    http.get("/occasion-pages")
      .then(({ data }) => setPages(Array.isArray(data) ? data : []))
      .catch(() => setPages([]));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-4 space-y-4" data-testid="gift-occasions-page">
      <div className="text-center space-y-1">
        <h1 className="text-2xl font-black">{ar ? "🎉 تسوّق حسب المناسبة" : "🎉 Shop by occasion"}</h1>
        <p className="text-xs opacity-60">
          {ar ? "اختر المناسبة ونعرض لك أنسب الورد والهدايا لها" : "Pick the occasion — we'll show the perfect gifts"}
        </p>
      </div>
      <Link to="/occasions"
            className="rounded-2xl p-3.5 flex items-center gap-3 card-soft"
            style={{ background: "rgba(176,141,77,0.08)" }} data-testid="my-occasions-link">
        <Bell size={20} className="text-amber-700 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-bold text-[13px]">{ar ? "مناسباتي وتذكيراتي" : "My occasions & reminders"}</div>
          <div className="text-[11px] opacity-60">
            {ar
              ? (user ? "سجّل مناسباتك الخاصة ونذكّرك قبلها بهدية مثالية" : "سجّل دخولك لحفظ مناسباتك وتذكيرك قبلها")
              : "Save your dates & get gift reminders"}
          </div>
        </div>
        <span className="text-xl opacity-40">{ar ? "‹" : "›"}</span>
      </Link>
      {pages === null ? (
        <div className="py-14 flex justify-center"><Loader2 className="animate-spin text-emerald-700" size={26} /></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="gift-occasions-grid">
          {pages.map((o) => (
            <Link key={o.slug} to={`/occasion/${o.slug}`}
                  className="group rounded-2xl overflow-hidden bg-white active:scale-95 transition-transform"
                  style={{ border: "1px solid rgba(0,0,0,0.06)", boxShadow: "0 2px 10px -4px rgba(0,0,0,0.08)" }}
                  data-testid={`gift-occasion-${o.slug}`}>
            <div className="relative aspect-[4/3] overflow-hidden flex items-center justify-center" style={{ background: "#f6f4f1" }}>
                <OccImg slug={o.slug} emoji={o.emoji} />
              </div>
              <div className="py-2 px-2 text-center text-[13px] font-bold">
                {o.emoji} {ar ? (SHORT_AR[o.slug] || o.title_ar) : (o.title_en || o.title_ar)}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
